import axios from 'axios';
import { normalizeGetTableQuery } from '@/utils/globalHelpers';

export class AdminService {
  async getAdmins(params) {
    return await axios.get('/api/v1/portal/user', { params: normalizeGetTableQuery(params) });
  }
  async createAdmin(data) {
    return await axios.post('/api/v1/portal/user', data);
  }
  async editAdmin(id, data) {
    return await axios.put(`/api/v1/portal/user/${id}`, data);
  }
  async getAdmin(id) {
    return await axios.get(`/api/v1/portal/user/${id}`);
  }
}
